import { Box } from "@mui/material";
import logo from "@src/shared/assets/logo_1.png";
import whatsappImg from "@src/shared/assets/whatsapp_img.svg";
import supportImg from "@src/shared/assets/letter_support_img.svg";
import { NavLink } from "react-router-dom";

import styles from "./styles.module.scss";

export const StubPage = () => {
  return (
    <>
      <Box className={styles.root}>
        <header className={styles.header}>
          <div className={styles.block}>
            <img src={logo} alt="logo" className={styles.logo} />
            <div className={styles.titleWrap}>
              <span className={styles.title}>
                Сервис по найму сотрудников 24/7
              </span>
            </div>
          </div>
        </header>
        <section className={styles.contentWrap}>
          <div className={styles.content}>
            <h1>Ведутся технические работы !</h1>
          </div>
        </section>
        <footer className={styles.footer}>
          <div className={styles.leftBlock}>
            <img src={logo} alt="logo" className={styles.logo} />
            <div className={styles.nameCompany}>
              <span>ООО «Цифра Лаб»</span>
            </div>
            <div className={styles.additionalInfo}>
              <div>
                <span>ИНН 9731004705</span>
              </div>
              <div>
                <span>КПП 773101001</span>
              </div>
            </div>
          </div>
          <div className={styles.rightBlock}>
            <div className={styles.top}>
              <div className={styles.time}>
                <span>9-18 МСК</span>
              </div>
              <div className={styles.whatsapp}>
                <NavLink
                  to="https://api.whatsapp.com/send/?phone=79300351166&text&type=phone_number&app_absent=0"
                  className={styles.navItem}
                >
                  <img src={whatsappImg} alt="переход на страницу whatsapp" />
                  <span>+7 (930) 035 - 11 - 66</span>
                </NavLink>
              </div>
            </div>

            <div className={styles.support}>
              <NavLink
                to="mailto:support@naimus.ai?subject=Вопрос по сервису&body=Здравствуйте!"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.navItem}
              >
                <img src={supportImg} alt="письмо в поддержку" />
                <span>support@naimus.ai</span>
              </NavLink>
            </div>
          </div>
        </footer>
      </Box>
    </>
  );
};
